export const getRenewalDate = (dateRendered: Date) =>
  `${dateRendered.toLocaleString('en-us', { month: 'long' })} ${dateRendered.getDate()}, ${dateRendered.getFullYear() + 1}`;
